import axios from "axios";

var DrugSearch = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },

    search: function (ln, ndc, gpi, pricingMode, benefitId, token) {
        return axios.get(Apollo.resolveApiUrl("~/drugsearch"), {
            params: {
                Ln: ln,
                NDC: ndc,
                GPI: gpi,
                BenefitId: benefitId,
                Zone: pricingMode.Zone,
                BenefitType: pricingMode.RetailMailStatus,
                Token: token
            }
        });
    },

    medicaresearch: function (ln, ndc, gpi, pricingMode, benefitId, token) {
        return axios.get(Apollo.resolveApiUrl("~/drugsearch/medicaresearch"), {
            params: {
                Ln: ln,
                NDC: ndc,
                GPI: gpi,
                BenefitId: benefitId,
                Zone: pricingMode.Zone,
                BenefitType: pricingMode.RetailMailStatus,
                Token: token
            }
        });
    },
    Multiformularysearch: function (ln, ndc, gpi, pricingMode, benefitId, benefitId2, benefitId3, benefitId4, benefitId5, benefitId6, benefitId7, benefitId8, benefitId9, benefitId10, token) {

        return axios.get(Apollo.resolveApiUrl("~/drugsearch/multiformulary"), {
            params: {
                Ln: ln,
                NDC: ndc,
                GPI: gpi,
                BenefitId: benefitId,
                BenefitId2: benefitId2,
                BenefitId3: benefitId3,
                BenefitId4: benefitId4,
                BenefitId5: benefitId5,
                BenefitId6: benefitId6,
                BenefitId7: benefitId7,
                BenefitId8: benefitId8,
                BenefitId9: benefitId9,
                BenefitId10: benefitId10,
                Zone: pricingMode.Zone,
                BenefitType: pricingMode.RetailMailStatus,
                Token: token
            }
        });
    }
};

export default DrugSearch;



// WEBPACK FOOTER //
// ./src/models/DrugSearch.js